module.exports = __webpack_public_path__ + "static/media/69-iveco.1b2a7363.jpg";